import { ResponsiveRowSelectedEvent } from './types';

export function createResponsiveRowSelectedEvent<TData>(
    data: TData | undefined,
    rowIndex: number,
    selected: boolean,
): ResponsiveRowSelectedEvent<TData> {
    return {
        data,
        rowIndex,
        selected,
        isSelected: () => selected,
    };
}
